import React from 'react';
import { reduxForm, Field } from 'redux-form';
import ModalBox from '../../../shared/modal';
import SelectField from '../../../shared/form-elements/select/field';

const Main = props =>
	<ModalBox
		title={props.intl('What type of approve do you need:')}
		body={PopupContent(props)}
		isOpen={props.isRequestForApprovePopupVisible}
		onClose={props.toggleRequestForApprovePopup}
	/>;

const PopupContent = props =>
	<form className="adv-request__wrap">
		<div className="ui-form__element padding-bottom-200">
			<Field
				name="reason"
				placeholder="Reason (mandatory!)"
				multi={false}
				component={SelectField}
				searchable={false}
				options={props.reasons.map(item => ({ value: item.id, label: item.text }))}
			/>
		</div>
		<div className="display-flex flex-center">
			{
				props.can('confirm') &&
				<button
					className="ui-btn ui-btn-primary margin-0-10"
					onClick={props.applyForApprove.bind(null, 'approve')}
				>
					Approve
				</button>
			}
			<button
				className="ui-btn ui-btn-cancel cancel margin-0-10"
				onClick={props.applyForApprove.bind(null, 'restrict_approve')}
			>
				Restrict approve
			</button>
		</div>
	</form>;

export default reduxForm({ form: 'requestApproveForm' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve-requests/components/forms/request-for-approve.js